import { useMutation } from "react-query";
import apiClient from "services/apiClient";

const useLogout = () =>
  useMutation(async (): Promise<void> => {
    await apiClient.post<void>("/v1/students/logout");
  });

export default useLogout;
